import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o'; 
import { Router } from '@angular/router';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { SymptomsCheckerService } from 'src/app/services/symptoms-checker.service';
import { intial_api, selectedParts, InitialSymptomsRequest, SelectSymptomsAgainstPart, symptomsAgainstBodyParts, SendQuestionAns } from 'src/app/models/symtomChecker/symptomsChecker';
import { NgxSpinnerService } from 'ngx-spinner';
import { PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
declare var $:any;
@Component({
  selector: 'app-symptoms-male',
  templateUrl: './symptoms-male.component.html',
  styleUrls: ['./symptoms-male.component.css']
})
export class SymptomsMaleComponent implements OnInit {
  pageNum:any;
  totalPages:any;
  patientPersonalInfo:any;
  
  customOptions: OwlOptions;
  InitialSymptomsResponce : any;
  InitialQuestionResponce: any;
  iniatobj  =new intial_api();
  settings:any;
  constructor(private translateService: TranslateService, private router:Router,private phrUtils:PhrutillsService,private SymptomsCheckerService:SymptomsCheckerService,private spinner: NgxSpinnerService,
    private datepipe: DatePipe) { 
      this.customOptions = {
        loop: true,
        autoplay: false,
        center: true, 
        margin: 0,
        dots: false,
        autoHeight: true,
        autoWidth: true, 
        nav: true,
        navText: [ 
          "<i class='fa fa-angle-left'></i>",
          "<i class='fa fa-angle-right'></i>"
        ],
        items: 1 
      }
      this.InitialSymptomsRequest = new InitialSymptomsRequest();
      let info = localStorage.getItem('PersonalInfo');
      if(!info){
        this.router.navigateByUrl("/");
        return;
      }
      this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
      if(this.patientPersonalInfo.GENDER.toLowerCase() == "female")
      {
        window.location.href = window.location.origin + '/patient/symptomsfemale';
        //this.router.navigateByUrl("/patient/symptomsfemale");
      }
      let havSetting = localStorage.getItem("financialCheck");
      if(havSetting){
        this.settings = JSON.parse(this.phrUtils.decrypt(havSetting));
      }
      let pagesorder=localStorage.getItem('pagesorder');
      this.pageNum =JSON.parse(pagesorder?pagesorder:'').symptoms_checker;
      this.totalPages=localStorage.getItem('totalPages');
    }
    
    ngOnInit(): void {
      // setTimeout(() => {
      //   this.customOptions = {
      //     loop: true,
      //     autoplay: false,
      //     center: true,
      //     margin: 0,
      //     dots: false,
      //     autoHeight: true,
      //     autoWidth: true,
      //     nav: true,
      //     navText: [
      //       "<i class='fa fa-angle-left'></i>",
      //       "<i class='fa fa-angle-right'></i>"
      //     ],
      //     items: 1,
      //   }
      // }, 3000);
   
      this.phrUtils.patientlanguage$.subscribe(language => {
        console.log("dafault " + language);
        if (language === 'es') {
          this.phrUtils.setTitle('Comprobador de síntomas');
        } else if (language === 'hi') {
          this.phrUtils.setTitle('लक्षण जांचकर्ता');
        }
        else if (language === 'ur') {
          this.phrUtils.setTitle('علامات کی جانچ کرنے والا');
        }
        else {
          this.phrUtils.setTitle('Symptom Checker');
        }
      });
      this.iniatobj.has_patient_active_med= true;
      this.iniatobj.last_icds_and_labs= "" ;
      this.iniatobj.patient_account= this.patientPersonalInfo.PATIENT_ACCOUNT;
      this.iniatobj.patient_dob= this.datepipe.transform(this.patientPersonalInfo.DOB, 'MM/dd/yyyy');
      this.iniatobj.patient_gender= this.patientPersonalInfo.GENDER;
      this.iniatobj.patient_rov= this.patientPersonalInfo.REASON_NAME;
      this.iniatobj.practice_code= this.patientPersonalInfo.PRACTICE_CODE;
      this.iniatobj.provider_code= this.patientPersonalInfo.PROVIDER_CODE;
      this.iniatobj.will_intake_form_show= true;
      let visitdate = localStorage.getItem('visitDate')
      if (visitdate) {
        this.iniatobj.dos = localStorage.getItem('visitDate');
      } else {
        this.iniatobj.dos = "";
      }
      this.spinner.show();
      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';
      this.translateService.use(lang);
      this.SymptomsCheckerService.initialQuestions(this.iniatobj,lang).subscribe((res:any)=>{
        this.spinner.hide();
        localStorage.setItem("AccessTokenSymptoms",res.access_token);
        this.InitialSymptomsResponce = res.payload ;
        if(this.InitialSymptomsResponce.screen == "form_screen")
        {
          this.router.navigateByUrl("/patient/symptomsquestion");
        }
        
      },(error :any)=>
      {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showError(text);
       // this.phrUtils.showError("Service is not available, please try later.")
      })
    }
    // ngAfterViewInit()
    // {
    //   this.customOptions = {
    //     loop: true,
    //     autoplay: false,
    //     center: true, 
    //     margin: 0,
    //     dots: false,
    //     autoHeight: true,
    //     autoWidth: true, 
    //     nav: true,
    //     navText: [ 
    //       "<i class='fa fa-angle-left'></i>",
    //       "<i class='fa fa-angle-right'></i>"
    //     ],
    //     items: 1, 
    //   }
    // }
    bodypart:any = '';
    bodyside : any = '';
    onSelectBodyPart(part:any,side:any)
    {
      
      $("#Symptoms-Modal").modal("show");
      
      if(this.bodypart != part)
      {
        this.bodypart = part;
        this.bodyside = side;
        this.selectedParts = [];
      }
      else if(side != 'no' && this.bodyside != side)
      {
        this.bodyside = side;
        this.selectedParts.map((res:any)=>{
          
          res.side = this.bodyside;
        })
      }
    }
    symptomsAgainstBodyParts:symptomsAgainstBodyParts[]=[];
    symptomsAgainstBodyPartsfilter:symptomsAgainstBodyParts[]=[];
    sendBodyParts()
    {
      this.symptomsAgainstBodyParts= [];
      if(this.selectedParts.length>0)
      {
        
        this.selectedParts.map((res:any)=>{
          if(res.main == 'head')
          {
            if(res.name == 'head')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.head.head.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'ear')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.head.ear.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'mouth')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.head.mouth.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'nose')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.head.nose.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'skin')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.head.skin.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'eye')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.head.eye.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'face')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.head.face.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'abdomen')
          {
            if(res.name == 'abdomen')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.abdomen.abdomen.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'skin')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.abdomen.skin.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'arm')
          {
            if(res.name == 'shoulder')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.arm.shoulder.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'elbow')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.arm.elbow.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'forearm')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.arm.forearm.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'Upper arm')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.arm['upper arm'].map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'neck')
          {
            if(res.name == 'neck')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree['neck/throat'].neck.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'skin')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree['neck/throat'].skin.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'chest')
          {
            if(res.name == 'chest')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.chest.chest.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'skin')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.chest.skin.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'genitals')
          {
            if(res.name == 'genitourinary')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.genitals.genitourinary.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'skin')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.genitals.skin.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'hand')
          {
            if(res.name == 'hand')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.hands.hands.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'skin')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.hands.skin.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'fingers')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.hands.fingers.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'wrist')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.hands.wrist.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'foot')
          {
            if(res.name == 'Ankle joint')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.foot['ankle joint'].map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'foot')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.foot.foot.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'toe')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.foot.toe.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'hip')
          {
            if(res.name == 'hip')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree['hip/buttock'].hip.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'skin')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree['hip/buttock'].skin.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'leg')
          {
            if(res.name == 'Hip')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.leg.hip.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'Thigh')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.leg.thigh.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'Knee')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.leg.knee.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'Calf')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.leg.calf.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
          else if(res.main == 'back')
          {
            if(res.name == 'back')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.back.back.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
            else if(res.name == 'skin')
            {
              this.InitialSymptomsResponce.question_options.anatomical_tree.back.skin.map((res1:any)=>
              {
                
                if(this.symptomsAgainstBodyParts.length > 0)
                {
                  if(this.symptomsAgainstBodyParts.filter(res2 => res2.name == res1 && res2.key == res.name).length==0)
                  {
                    let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                    symptomsAgainstBodyPart.main = res.main;
                    symptomsAgainstBodyPart.key = res.name;
                    symptomsAgainstBodyPart.name = res1;
                    symptomsAgainstBodyPart.side = res.side;
                    this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                  }
                }else
                {
                  let symptomsAgainstBodyPart = new symptomsAgainstBodyParts();
                  symptomsAgainstBodyPart.main = res.main;
                  symptomsAgainstBodyPart.key = res.name;
                  symptomsAgainstBodyPart.name = res1;
                  symptomsAgainstBodyPart.side = res.side;
                  this.symptomsAgainstBodyParts.push(symptomsAgainstBodyPart);
                }
              })
            }
          }
        })
        this.symptomsAgainstBodyPartsfilter = this.symptomsAgainstBodyParts;
        $("#Select-Symptoms-Modal").modal("show");
        this.spinner.show();
        setTimeout(() => {
          if(this.SelectSymptomsAgainstPart.length>0)
          {
            this.openSymptomsModel();
          }
          this.spinner.hide();
        }, 500);
        
      }
      else
      {
        let text = "Please select atleast one body part.";
        this.translateService.get('Alerts.please_select_atleast_one_bodypart').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showInfo(text);
       // this.phrUtils.showInfo('Please select atleast one body part.');
      }
    }
    selectedParts:selectedParts[]=[];
    SelectPartChange(data:any)
    {
      
      if(this.selectedParts.length > 0)
      {
        if(this.selectedParts.filter(res => res.name == data.target.id).length == 0)
        {
          let selectpart = new selectedParts();
          selectpart.id = this.selectedParts[this.selectedParts.length-1].id+1;
          selectpart.name = data.target.value;
          selectpart.main = this.bodypart;
          selectpart.side = this.bodyside;
          this.selectedParts.push (selectpart);
        }
        else
        {
          if(!data.target.checked)
          { 
            let bodypartremove = this.selectedParts.filter(res => res.name == data.target.id);
            let selectpart:selectedParts[] = [];
            selectpart = this.selectedParts;    
            this.selectedParts = [];
            selectpart.map((res:any)=>{
              if(res.name != bodypartremove[0].name)
              this.selectedParts.push(res);
            })   
          }
        }
      }
      else
      {
        let selectpart = new selectedParts();
        selectpart.id=1;
        selectpart.name = data.target.value;
        selectpart.main = this.bodypart;
        selectpart.side = this.bodyside;
        this.selectedParts.push (selectpart);
      } 
    }
    PatientBodySymptomsSelect(event:any)
    {
      this.symptomsAgainstBodyPartsfilter = [];
      this.symptomsAgainstBodyPartsfilter = this.symptomsAgainstBodyParts.filter(x => x.name.toLowerCase().includes(event.target.value.toLowerCase()));
      
    }
    SelectSymptomsAgainstPart : SelectSymptomsAgainstPart[]=[];
    SelectBodySymptoms(data:any,event:any)
    {
      
      if(this.SelectSymptomsAgainstPart.length > 0)
      {
        if(this.SelectSymptomsAgainstPart.filter(res => res == data ).length == 0)
        {
          let SelectSymptomsAgainstPartSingle = new SelectSymptomsAgainstPart();
          SelectSymptomsAgainstPartSingle = data;
          this.SelectSymptomsAgainstPart.push(SelectSymptomsAgainstPartSingle);
        }
        else
        {
          if(!event.target.checked)
          { 
            let bodySymptomremove = this.SelectSymptomsAgainstPart.filter(res => res == data);
            let SelectSymptomsAgainstPartDummy:SelectSymptomsAgainstPart[] = [];
            SelectSymptomsAgainstPartDummy = this.SelectSymptomsAgainstPart;    
            this.SelectSymptomsAgainstPart = [];
            SelectSymptomsAgainstPartDummy.map((res:any)=>{
              if(res.name != bodySymptomremove[0].name && res.key == bodySymptomremove[0].key && res.side == bodySymptomremove[0].side)
              this.SelectSymptomsAgainstPart.push(res);
            })   
          }
        }
      }
      else
      {
        let SelectSymptomsAgainstPartSingle = new SelectSymptomsAgainstPart();
        SelectSymptomsAgainstPartSingle= data;
        this.SelectSymptomsAgainstPart.push(SelectSymptomsAgainstPartSingle);
      } 
    }
    finishSymptomsSelection()
    {
      $("#Symptoms-Modal").modal("hide");
      $("#symptomModelMore").modal("show");
    }
    deleteSelectedSymptoms(data:any)
    {
      
      let bodySymptomremove = this.SelectSymptomsAgainstPart.filter(res => res == data);
      let SelectSymptomsAgainstPartDummy:SelectSymptomsAgainstPart[] = [];
      SelectSymptomsAgainstPartDummy = this.SelectSymptomsAgainstPart;    
      this.SelectSymptomsAgainstPart = [];
      SelectSymptomsAgainstPartDummy.map((res:any)=>{
        if(res.name != bodySymptomremove[0].name && res.key == bodySymptomremove[0].key && res.side == bodySymptomremove[0].side)
        this.SelectSymptomsAgainstPart.push(res);
      });
      if((/\s/).test(data.name) || (/\s/).test(data.side))
      {
        $('[id="'+data.name+data.key+data.main+data.side+'"]').prop("checked", false);
      }
      else
      {
        $("#"+data.name+data.key+data.main+data.side).prop("checked", false);
      }
    }
    openSymptomsModel()
    {
      
      this.SelectSymptomsAgainstPart.map((res:any) =>
      {
        if((/\s/).test(res.name) || (/\s/).test(res.side))
        {
          $('[id="'+res.name+res.key+res.main+res.side+'"]').prop("checked", true);
        }
        else
        {
          $("#"+res.name+res.key+res.main+res.side).prop("checked", true);
        }
      })
    }
    InitialSymptomsRequest : any;
    ContinueSelection(){
      
      let data:any;
      let mainarray : any;
      let childarray:any;
      let SymptomsNameHead:any="";
      this.InitialSymptomsRequest.patient_account = this.patientPersonalInfo.PATIENT_ACCOUNT;
      if(this.SelectSymptomsAgainstPart.length > 0)
      {
        this.SelectSymptomsAgainstPart.map((res:any)=>{
          if(res.side == 'no')
          {
            SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
            if(this.InitialSymptomsRequest.anatomical_selected[res.main])
            {
              if(this.InitialSymptomsRequest.anatomical_selected[res.main][res.key.toLowerCase()])
              {
                this.InitialSymptomsRequest.anatomical_selected[res.main][res.key.toLowerCase()].push(res.name);
              }
              else 
              {
                this.InitialSymptomsRequest.anatomical_selected[res.main][res.key.toLowerCase()] = [res.name];
              }
            }
            else
            {
              this.InitialSymptomsRequest.anatomical_selected[res.main] = { [res.key.toLowerCase()] : [res.name]}
            }
          }
          else
          {
            SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
            if(this.InitialSymptomsRequest.anatomical_selected[res.side])
            {
              if(this.InitialSymptomsRequest.anatomical_selected[res.side][res.key.toLowerCase()])
              {
                this.InitialSymptomsRequest.anatomical_selected[res.side][res.key.toLowerCase()].push(res.name);
              }
              else 
              {
                this.InitialSymptomsRequest.anatomical_selected[res.side][res.key.toLowerCase()] = [res.name];
              }
            }
            else
            {
              this.InitialSymptomsRequest.anatomical_selected[res.side] = { [res.key.toLowerCase()] : [res.name]}
            }
          }
          // if(res.main == 'head')
          // {
          //   if(res.key == 'head')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     if(this.InitialSymptomsRequest.anatomical_selected[res.main])
          //     {
          //       if(this.InitialSymptomsRequest.anatomical_selected[res.main][res.key])
          //       {
          //         this.InitialSymptomsRequest.anatomical_selected[res.main][res.key].push(res.name);
          //       }
          //       else 
          //       {
          //         this.InitialSymptomsRequest.anatomical_selected[res.main][res.key] = [res.name];
          //       }
          //     }
          //     else
          //     {
          //       this.InitialSymptomsRequest.anatomical_selected[res.main] = { [res.key] : [res.name]}
          //     }
          //   }
          //   else if(res.key == 'nose')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     if(this.InitialSymptomsRequest.anatomical_selected.head)
          //     this.InitialSymptomsRequest.anatomical_selected.head[res.key] = [res.name];
          //   }
          //   else if(res.key == 'mouth')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected[res.main] = { [res.key] : [res.name]}
          //   }
          //   else if(res.key == 'face')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected[res.main] = { [res.key] : [res.name]}
          //   }
          //   else if(res.key == 'skin')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.head.skin.push(res.name);
          //   }
          //   else if(res.key == 'ear')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.head.ear.push(res.name);
          //   }
          //   else if(res.key == 'eye')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.head.eye.push(res.name);
          //   }
          // }
          // else if(res.main == 'hand')
          // {
          //   if(res.key == 'hand')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.hands.hands.push(res.name);
          //   }
          //   else if(res.key == 'wrist')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.hands.wrist.push(res.name);
          //   }
          //   else if(res.key == 'fingers')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.hands.fingers.push(res.name);
          //   }
          //   else if(res.key == 'skin')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.hands.skin.push(res.name);
          //   }
          // }
          // else if(res.main == 'abdomen')
          // {
          //   if(res.key == 'abdomen')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected[res.main] = { [res.key] : [res.name]}
          //   }
          //   else if(res.key == 'skin')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.abdomen.skin.push(res.name);
          //   }
          // }
          // else if(res.main == 'arm')
          // {
          //   if(res.key == 'shoulder')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.arm.shoulder.push(res.name);
          //   }
          //   else if(res.key == 'Upper arm')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.arm['upper arm'].push(res.name);
          //   }
          //   else if(res.key == 'elbow')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.arm.elbow.push(res.name);
          //   }
          //   else if(res.key == 'forearm')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.arm.forearm.push(res.name);
          //   }
          // }
          // else if(res.main == 'back')
          // {
          //   if(res.key == 'back')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.back.back.push(res.name);
          //   }
          //   else if(res.key == 'skin')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.back.skin.push(res.name);
          //   }
          // }
          // else if(res.main == 'chest')
          // {
          //   if(res.key == 'chest')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.chest.chest.push(res.name);
          //   }
          //   else if(res.key == 'skin')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.chest.skin.push(res.name);
          //   }
          // }
          // else if(res.main == 'foot')
          // {
          //   if(res.key == 'foot')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     // if(res.side == 'right_foot')
          //     this.InitialSymptomsRequest.anatomical_selected[res.side][res.key].push(res.name);
          //     // if(res.side == 'left_foot')
          //     // this.InitialSymptomsRequest.anatomical_selected.left_foot.foot.push(res.name);
          //   }
          //   else if(res.key == 'toe')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.foot.toe.push(res.name);
          //   }
          //   else if(res.key == 'Ankle joint')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.foot['ankle joint'].push(res.name);
          //   }
          // }
          // else if(res.main == 'genitals')
          // {
          //   if(res.key == 'genitourinary')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.genitals.genitourinary.push(res.name);
          //   }
          //   else if(res.key == 'skin')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.genitals.skin.push(res.name);
          //   }
          // }
          // else if(res.main == 'hip')
          // {
          //   if(res.key == 'hip')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.hip.hip.push(res.name);
          //   }
          //   else if(res.key == 'skin')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.hip.skin.push(res.name);
          //   }
          // }
          // else if(res.main == 'leg')
          // {
          //   if(res.key == 'Hip')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.leg.hip.push(res.name);
          //   }
          //   else if(res.key == 'Thigh')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.leg.thigh.push(res.name);
          //   }
          //   else if(res.key == 'Knee')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.leg.knee.push(res.name);
          //   }
          //   else if(res.key == 'Calf')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.leg.calf.push(res.name);
          //   }
          // }
          // else if(res.main == 'neck')
          // {
          //   if(res.key == 'neck')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.neck.neck.push(res.name);
          //   }
          //   else if(res.key == 'skin')
          //   {
          //     SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //     this.InitialSymptomsRequest.anatomical_selected.neck.skin.push(res.name);
          //   }
          // }
          // else if(res.main == 'General')
          // {
          //   SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //   this.InitialSymptomsRequest.anatomical_selected.General.General.push(res.name);
          // }
          // else if(res.main == 'Psychiatric')
          // {
          //   SymptomsNameHead = SymptomsNameHead ? SymptomsNameHead +','+res.name : res.name;
          //   this.InitialSymptomsRequest.anatomical_selected.Psychiatric.Psychiatric.push(res.name);
          // }
        })
        this.InitialSymptomsRequest.answer = SymptomsNameHead;
        this.spinner.show();
        let lang = localStorage.getItem('language');
        if (!lang)
          lang = 'en';
        this.translateService.use(lang);
        console.log("lang"+lang)
        this.SymptomsCheckerService.initialSymptoms(this.InitialSymptomsRequest, lang).subscribe((res:any)=>{
          this.spinner.hide();
          this.router.navigateByUrl("/patient/symptomsquestion");
          
        },(error :any)=>
        {
          this.spinner.hide();
          this.phrUtils.showError("Service is not available, please try later.");
        })
      }
      else
      {
        let text = "Please select body symptoms";
        this.translateService.get('Alerts.please_select_body_symptoms').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showInfo(text);
        //this.phrUtils.showInfo("Please select body symptoms");
        return;
      }
    }
    
    CanNotFindSymp()
    {
      this.symptomsAgainstBodyParts =[];
      this.InitialSymptomsResponce.question_options.anat_order.General.map((res:any) =>{
        let symptomsAgainstGeneraldummy = new symptomsAgainstBodyParts();
        symptomsAgainstGeneraldummy.key = "General";
        symptomsAgainstGeneraldummy.main = "General";
        symptomsAgainstGeneraldummy.side = "no";
        symptomsAgainstGeneraldummy.name = res;
        this.symptomsAgainstBodyParts.push(symptomsAgainstGeneraldummy);
      })
      if(this.settings.data.enable_Psychiatric_Symptom.toLowerCase() =='true')
      {
        this.InitialSymptomsResponce.question_options.anat_order.Psychiatric.map((res:any) =>{
          let symptomsAgainstGeneraldummy = new symptomsAgainstBodyParts();
          symptomsAgainstGeneraldummy.key = "Psychiatric";
          symptomsAgainstGeneraldummy.main = "Psychiatric";
          symptomsAgainstGeneraldummy.side = "no";
          symptomsAgainstGeneraldummy.name = res;
          this.symptomsAgainstBodyParts.push(symptomsAgainstGeneraldummy);
        })
      }
      this.symptomsAgainstBodyPartsfilter = this.symptomsAgainstBodyParts;
      $("#Select-Symptoms-Modal").modal("show");
      this.spinner.show();
      setTimeout(() => {
        if(this.SelectSymptomsAgainstPart.length>0)
        {
          this.openSymptomsModel();
        }
        this.spinner.hide();
      }, 500);
    }
    backclick()
    {
      this.router.navigateByUrl('patient/insurance');
    }
  }
